import { render, staticRenderFns } from "./CandidateRoom.vue?vue&type=template&id=29896f2a&scoped=true"
import script from "./CandidateRoom.vue?vue&type=script&lang=js"
export * from "./CandidateRoom.vue?vue&type=script&lang=js"
import style0 from "./CandidateRoom.vue?vue&type=style&index=0&id=29896f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29896f2a",
  null
  
)

export default component.exports